import { useMemo } from 'react';
import { usePossibleUser } from './useProfile';

export const usePermissions = (...perms: string[]) => {
  const user = usePossibleUser();
  return useMemo(
    () => (user ? perms.every((permission) => user.permissions?.has(permission)) : false),
    [user]
  );
};
